export default __webpack_public_path__ + "static/media/element_57.ff358cfa.jpg";